export default class CreateEventViewModel {
    public name: string = '';
    public entitlementEffect: string = '';
    public color: string = '';
    public icon: string = '';
    public canRequest?: boolean = true;
    public bradfordFactor?: boolean = false;
    public toilHours?: number = 1;
    public toilExpiry?: number = 30;
}